﻿import {useEventListener} from "./useEventListener";
import {ref, onMounted} from "vue";

export const useTextAreaAutoSize = (maxRows: number) => {

    const textAreaElement = ref<HTMLTextAreaElement>();

    let _resize = () => {
    }

    onMounted(() => {
        const element = <HTMLTextAreaElement>textAreaElement.value;
        const style = window.getComputedStyle(element);
        const verticalPadding = parseInt(style.paddingTop) + parseInt(style.paddingBottom);
        const verticalBorder = parseInt(style.borderTop) + parseInt(style.borderBottom);
        const lineHeight = (parseInt(style.height) - verticalPadding - verticalBorder) / element.rows;
        const maxHeight = maxRows * lineHeight + verticalPadding + verticalBorder;
        element.rows = 1;
        element.style.resize = "none"

        _resize = () => {
            element.style.height = "auto";
            element.style.height = Math.min(maxHeight, element.scrollHeight + verticalBorder) + "px";
        }

        _resize();
        useEventListener(element, "input", _resize);
    });


    return {
        textAreaElement,
        resize: () => _resize()
    }
}